/* KinderPod 2-seater builder — Depo deposit wiring.
   The builder adds to cart via a custom AJAX call (no Shopify product form),
   so Depo cannot attach its widget or its line-item properties on its own.
   A hidden {% form 'product' %} (#kpxDepoForm) is rendered in the buy box so
   Depo attaches + renders its widget there; this script harvests the selected
   plan's line-item properties and applies them to every item in /cart/add.js
   so the 25% deposit reaches checkout. Falls back to full-price add if Depo
   is unavailable. */
(function () {
  var css =
    ".kpx-depo-host{margin:2px 0 14px}" +
    ".kpx-depo-host form{margin:0;position:relative}" +
    ".kpx-depo-host .kpx-depo-add{position:absolute;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none}" +
    ".kpx-depo-host .depo-po-container{margin:0}" +
    ".kpx-depo-host .depo-branding{font-size:11px;opacity:.6}";
  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var btn = document.getElementById("kpxBuildAdd");
    var root = document.getElementById("kpxAddons");
    if (!btn || !root) return;

    // The phantom Depo form must never do a full-page POST.
    var kdf = document.getElementById("kpxDepoForm");
    if (kdf) kdf.addEventListener("submit", function (e) { e.preventDefault(); });

    // Build the Depo line-item properties for a given unit price (in pence).
    // Returns null for Full Payment / when Depo hasn't rendered (safe fallback).
    function depoProps(unitPence) {
      var f = document.getElementById("kpxDepoForm");
      if (!f) return null;
      var r = f.querySelector(".depo-pp-radio:checked");
      if (!r || /part-payment-full/.test(r.className)) return null;
      // Depo appends several property-input sets; the active selection is the last one.
      function val(n) {
        var e = f.querySelectorAll('input[name="properties[' + n + ']"]');
        return e.length ? e[e.length - 1].value : null;
      }
      var pct = parseFloat(val("_pp_percentage")) || 0;
      if (!pct) return null;
      var amt = unitPence * pct / 10000; // pounds per unit
      var p = {};
      p["_flow"] = val("_flow") || "part_payment";
      p["_part_payment_id"] = val("_part_payment_id") || "";
      p["_pp_percentage"] = val("_pp_percentage") || String(pct);
      p["_deposit_charge_flow"] = val("_deposit_charge_flow") || "no_charge";
      p["_deposit_charge_ratio"] = val("_deposit_charge_ratio") || "0.0";
      p["_cart_flow"] = val("_cart_flow") || "cart_v3";
      p["_part_payment_amount"] = amt.toFixed(2);
      p["Part Payment Amount(per product)"] = "£" + amt.toFixed(2);
      return p;
    }

    btn.addEventListener("click", function () {
      var basePence = parseInt(root.getAttribute("data-base")) || 0;
      var bdp = depoProps(basePence);
      var base = { id: root.getAttribute("data-base-variant"), quantity: 1 };
      if (bdp) base.properties = bdp;
      var items = [base];

      [].slice.call(document.querySelectorAll(".kpx-adn")).forEach(function (a) {
        var q = parseInt(a.querySelector(".kpx-adn__n").textContent) || 0;
        var v = a.getAttribute("data-variant");
        var pp = parseInt(a.getAttribute("data-price")) || 0;
        if (q > 0 && v) {
          var dp = depoProps(pp);
          var it = { id: v, quantity: q };
          if (dp) it.properties = dp;
          items.push(it);
        }
      });

      btn.disabled = true;
      var o = btn.textContent;
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw 0; window.location = "/cart"; })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = o;
          alert("Sorry, something went wrong adding to cart.");
        });
    });
  });
})();
